/* Boutons de filtres : chacun ouvre le tiroir du thème réduit à un seul filtre. */
(() => {
  if (window.__facetsBar) return;
  window.__facetsBar = true;

  const OPENERS = [
    { drawer: 'FacetDrawer', button: '.facet-wrapper > button[aria-controls="FacetDrawer"]' },
    { drawer: 'FacetDrawerSticky', button: 'facet-sticky > button[aria-controls="FacetDrawerSticky"]' }
  ];
  let programmatic = false;

  const visible = (el) => !!el && el.getClientRects().length > 0;

  const findOpener = () => {
    for (const o of OPENERS) {
      const button = document.querySelector(o.button);
      if (visible(button)) return { button, drawer: document.getElementById(o.drawer) };
    }
    return null;
  };

  const unscope = (drawer) => {
    if (!drawer) return;
    delete drawer.dataset.only;
    drawer.querySelectorAll('.facets-bar-off').forEach((el) => el.classList.remove('facets-bar-off'));
    const title = drawer.querySelector('.drawer__title');
    if (title && title.dataset.titleOrig) {
      title.textContent = title.dataset.titleOrig;
      delete title.dataset.titleOrig;
    }
  };

  const scope = (drawer, param, label) => {
    unscope(drawer);
    drawer.dataset.only = param;
    drawer.querySelectorAll('[data-filter]').forEach((el) => {
      if (el.hasAttribute('hidden')) return;
      const keep = (el.getAttribute('data-index') || '').endsWith(param);
      if (!keep) el.classList.add('facets-bar-off');
      else if (el.tagName === 'DETAILS') { el.open = true; el.classList.add('active'); }
    });
    const title = drawer.querySelector('.drawer__title');
    if (title) { title.dataset.titleOrig = title.textContent; title.textContent = label; }
  };

  const refreshCounts = () => {
    document.querySelectorAll('[data-bar-filter]').forEach((pill) => {
      const param = pill.getAttribute('data-bar-filter');
      const values = new Set();
      document.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        if (input.name === param) values.add(input.value);
      });
      const badge = pill.querySelector('[data-bar-count]');
      if (badge) { badge.textContent = values.size; badge.hidden = values.size === 0; }
      pill.classList.toggle('is-active', values.size > 0);
    });
  };

  document.addEventListener('click', (event) => {
    const pill = event.target.closest && event.target.closest('[data-bar-filter]');
    if (pill) {
      const opener = findOpener();
      if (!opener || !opener.drawer) return;
      scope(opener.drawer, pill.getAttribute('data-bar-filter'), pill.getAttribute('data-bar-label'));
      programmatic = true;
      opener.button.click();
      programmatic = false;
      return;
    }
    // Le bouton « Afficher les filtres » du thème rouvre le tiroir complet.
    const native = event.target.closest && event.target.closest(OPENERS.map((o) => o.button).join(','));
    if (native && !programmatic) {
      OPENERS.forEach((o) => unscope(document.getElementById(o.drawer)));
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest && event.target.closest('form[is="facet-form"]')) refreshCounts();
  });
  document.addEventListener('collection:reloaded', refreshCounts);
  refreshCounts();
})();
